const templateSet = new Set<Template>();

export function appendTemplates(templates: Template[]) {
  templates.forEach((template) => templateSet.add(template));
}

export function resolveAllTemplates() {
  return [...templateSet];
}
